<template>
  <div class="male-signin-root" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <div class="left-nav"></div>
          <span class="tit-left">{{ $t('lang.mybean.bonus') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <template v-if="signList && signList.length">
      <div class="male-signin-seven">
        <div class="signin-seven-check"></div>
        <div class="signin-seven-con">
          <div class="sign-seven-tit">{{ $t('lang.commonM.k439') }}</div>
          <div class="sign-seven-props">
            <template v-for="(item, index) in signList">
              <div
                class="sign-seven-item"
                :class="{
                  'item-on': !item.past,
                  'item-off': item.past,
                  'item-long': index === signList.length - 1 && item.rewardDataList && item.rewardDataList.length === 2,
                  'current-on': item.ifCurDay
                }"
              >
                <div class="seven-item-block">
                  <div v-for="(ele, idx) in item.rewardDataList" :key="index">
                    <template v-if="propsMap[ele.rewardPropType]">
                      <img v-if="item.past" :src="getMatchImg(`${propsMap[ele.rewardPropType]}-off`)" />
                      <img v-else :src="getMatchImg(propsMap[ele.rewardPropType])" />
                    </template>
                    <span>x{{ ele.rewardPropNumber || '?' }}</span>
                  </div>
                </div>
                <div class="seven-item-day">
                  <div v-if="!item.ifCurDay && item.ifSigned" class="got"></div>
                  <template v-else>{{ $t('lang.sevenKeepSignin.day') }}{{ item.index }}</template>
                </div>
              </div>
              <div v-if="signList[index + 1] && index !== 3" class="seven-gap"></div>
            </template>
          </div>
        </div>
      </div>

      <!-- prettier-ignore -->
      <template v-if="currentDay">
        <div class="sign-btn" v-if="currentDay.ifSigned">
          <div class="sign-btn-icon"></div>
          {{ $t('lang.commonM.k293') }} {{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}
        </div>

        <div class="sign-btn btn-on" v-else @click="handleSignIn">
          {{ $t('lang.sevenKeepSignin.signin') }}
        </div>
      </template>
    </template>

    <!-- banner -->
    <div class="banner-swipe" v-if="serviceAdvantageData && serviceAdvantageData.length">
      <swiper class="swiper-root" :options="swiperOptions">
        <swiper-slide v-for="item in serviceAdvantageData" :key="item.id">
          <div class="slide-item" @click="handleJumpPathFromBanner(item, 'goUrl')">
            <img :src="item.content | imgPath" />
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <!-- Beginner Tasks -->
    <div class="task-block" v-if="newerTask && newerTask.length">
      <div class="task-bg"></div>
      <div class="task-top">
        <div class="task-head">{{ $t('lang.commonM.k441') }}</div>
        <div v-if="expries" class="task-tips">{{ $t('lang.commonM.k446') }} {{ expries }}</div>
      </div>
      <div class="task-item" v-for="(item, index) in newerTask" :key="index" :id="`beginner${item.eventId}`">
        <div class="item-icon">
          <img :src="item.icon | imgPath" />
        </div>
        <div class="item-con">
          <p>{{ item.title }} ({{ item.process }})</p>
          <!-- prettier-ignore -->
          <div v-if="item.rewardType !== '?'">
            <img :src="getMatchImg(item.rewardType)" />x{{item.rewardNum}}
          </div>
        </div>
        <div class="item-btn-wrap">
          <div v-if="item.state === 0" class="item-btn start" @click="handleJumpPath(item, 'gotoUrl')">
            {{ $t('lang.commonM.k442') }}
          </div>
          <div v-if="item.state === 1" class="item-btn claim" @click="handleClaim(item)">
            {{ $t('lang.commonM.k073') }}
          </div>
          <div v-if="item.state === 2" class="item-btn got">
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Daily Tasks -->
    <div class="task-block" v-if="dailyTask && dailyTask.length">
      <div class="task-bg"></div>
      <div class="task-top">
        <div class="task-head">{{ $t('lang.commonM.k225') }}</div>
        <div class="task-tips">{{ $t('lang.commonM.k440') }}</div>
      </div>
      <div class="task-item" v-for="(item, index) in dailyTask" :key="index" :id="`daily${item.eventId}`">
        <div class="item-icon">
          <img :src="item.icon | imgPath" />
        </div>
        <div class="item-con">
          <p>{{ item.title }} ({{ item.process }})</p>
          <!-- prettier-ignore -->
          <div v-if="item.rewardType !== '?'">
            <img :src="getMatchImg(item.rewardType)" />x{{item.rewardNum}}
          </div>
        </div>
        <div class="item-btn-wrap">
          <div v-if="item.state === 0" class="item-btn start" @click="handleJumpPath(item, 'gotoUrl')">
            {{ $t('lang.commonM.k442') }}
          </div>
          <div v-if="item.state === 1" class="item-btn claim" @click="handleClaim(item)">
            {{ $t('lang.commonM.k073') }}
          </div>
          <div v-if="item.state === 2" class="item-btn got">
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 100px"></div>

    <div v-if="showReward" class="mask">
      <div v-if="showReward === 1" class="dia-con reward1">
        <div class="dia-top">
          <div class="dia-tit">{{ $t('lang.commonM.k147') }}!</div>
        </div>

        <!-- prettier-ignore -->
        <div class="reward-con">
          <div v-if="taskReward.rewardType !== '?'" class="reward-item">
            <img :src="getMatchImg(taskReward.rewardType)" alt="" /> x{{ taskReward.rewardNum || '-' }}
          </div>
        </div>

        <div class="dia-btn" @click="showReward = false">{{ $t('lang.ok') }}</div>
      </div>

      <div v-if="showReward === 2" class="dia-con reward2">
        <div class="dia-top">
          <div class="dia-tit">{{ $t('lang.commonM.k085') }}</div>
          <p class="dia-tips">{{ $t('lang.commonM.k443') }}</p>
        </div>

        <!-- prettier-ignore -->
        <div class="reward-con">
          <div class="reward-item" v-for="(item, index) in signInReward" :key="index" :class="{only: signInReward && signInReward.length === 1}">
            <img v-if="item.rewardType !== '?'" :src="getMatchImg(item.rewardType)" alt="" /> x{{ item.rewardNum }}
          </div>
        </div>

        <div class="dia-btn" @click="showReward = false">{{ $t('lang.ok') }}</div>

        <div class="dia-bottom" @click="handleRemind">
          <div class="switch-block" :class="{ on: remindStatus, off: !remindStatus }"></div>
          <span>{{ $t('lang.commonM.k444') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/SignIn/z-style-cfg.js'

import { getMaleSigninData, getMaleTasksData, maleTaskSignin, maleTaskClaim, maleTaskRemind } from '@/api/imee.js'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import countDown from '@/mixin/count-down.js'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  mixins: [pageCssVars, countDown],
  data() {
    return {
      // 签到
      currentDay: null,
      signList: [],
      // banner
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        centeredSlides: true,
        paginationClickable: true,
        autoplay: false
      },
      serviceAdvantageData: [
        // {
        //   content: 'public/app/banner/banner_beer2prop_en.png',
        //   goUrl: 'iMee://open_web_inside?url=beer-collect',
        //   priority: 1
        // }
      ],
      // beginner
      expries: '',
      newerTask: [],
      // daily
      dailyTask: [],

      // 奖励
      showReward: 0,
      signInReward: null,
      taskReward: null,
      remindStatus: false

      // 奖励mock
      // showReward: 2,
      // signInReward: [
      //   {
      //     rewardType: 'chat-pass',
      //     rewardNum: 2
      //   },
      //   {
      //     rewardType: 'chat-pass',
      //     rewardNum: 2
      //   }
      // ],
      // taskReward: {
      //   rewardType: 'chat-pass',
      //   rewardNum: 2
      // },
      // remindStatus: true
    }
  },
  methods: {
    // 跳转到指定锚点
    scrollToAnchor(jumpId) {
      const element = document.getElementById(jumpId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth' // 平滑滚动
        })
      }
    },
    handleRemind() {
      if (this.remindStatus === false) {
        maleTaskRemind(1).then((resData) => {
          if (resData && !resData.error) {
            this.remindStatus = true
          }
        })
        return
      }
      if (this.remindStatus === true) {
        maleTaskRemind(0).then((resData) => {
          if (resData && !resData.error) {
            this.remindStatus = false
          }
        })
        return
      }
    },
    handleSignIn() {
      maleTaskSignin().then((resData) => {
        if (resData && !resData.error) {
          this.remindStatus = !!resData.ifRemind
          if (this.currentDay && this.currentDay.rewardDataList && this.currentDay.rewardDataList.length) {
            this.signInReward = this.currentDay.rewardDataList.map((ele) => {
              const type = this.propsMap[ele.rewardPropType]
              const num = ele.rewardPropNumber
              return {
                rewardType: type,
                rewardNum: num
              }
            })
            this.showReward = 2
          }

          this.init()
        }
      })
    },
    handleJumpPathFromBanner(item, urlField) {
      item[urlField] && this.appActionPro(item[urlField])
    },
    handleJumpPath(item, urlField) {
      this.closeWeb()
      let timer = setTimeout(() => {
        timer = null
        item[urlField] && this.appActionPro(item[urlField])
      }, 100)
    },
    handleClaim(item) {
      // this.taskReward = item
      // this.showReward = 1

      if (item.taskId && item.conditionId) {
        maleTaskClaim(item.taskId, item.conditionId).then((resData) => {
          if (resData && !resData.error) {
            this.taskReward = item
            this.showReward = 1

            this.init()
          }
        })
      }
    },
    transformTaskData(taskList) {
      let result = []
      try {
        if (Array.isArray(taskList)) {
          taskList.forEach((ele) => {
            const tempObj = { ...ele, conditionId: '', process: '0/0', rewardType: '?', rewardNum: '', state: '' }
            tempObj.conditions = null

            if (ele.conditions && ele.conditions.length) {
              if (ele.conditions[0].rewardList && ele.conditions[0].rewardList.length) {
                tempObj.rewardType = this.propsMap[ele.conditions[0].rewardList[0].rewardPropType]
                tempObj.rewardNum = ele.conditions[0].rewardList[0].rewardPropNum
              }
              tempObj.process = `${ele.conditions[0].proc}/${ele.conditions[0].goal}`
              tempObj.state = ele.conditions[0].state
              tempObj.conditionId = ele.conditions[0].conditionId
            }

            result.push(tempObj)
          })
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
      return result
    },
    init() {
      getMaleSigninData().then((resData) => {
        if (resData && !resData.error) {
          if (resData && resData.length) {
            try {
              const current = resData.find((ele) => ele.ifCurDay)
              this.currentDay = current
              if (current.ifSigned) {
                this.initCountDown(new Date(`${current.day} 23:59:59`).getTime(), false, true)
              }
              const currentDay = new Date(current.day).getTime()
              resData.forEach((ele) => {
                if (new Date(ele.day).getTime() < currentDay) {
                  ele.past = true
                }
              })
            } catch (err) {
              console.log('try catch err:', err)
            }
            this.signList = resData
          }
        }
      })
      getMaleTasksData().then((resData) => {
        if (resData && !resData.error) {
          // banners
          if (resData.banners && resData.banners.length) {
            this.serviceAdvantageData = resData.banners
          }

          // 过期时间
          if (resData.newerTaskExpired) {
            const temp = resData.newerTaskExpired - Date.now()
            if (temp > 0) {
              this.expries = this.transformSeconds2(temp / 1000)
            }
          }

          // newerTask
          if (resData.newerTask && resData.newerTask.length) {
            let result = []
            let tempTask = this.transformTaskData(resData.newerTask)
            result = result.concat(tempTask.filter((ele) => ele.state === 1))
            result = result.concat(tempTask.filter((ele) => ele.state === 0))
            result = result.concat(tempTask.filter((ele) => ele.state === 2))
            this.newerTask = result

            this.$nextTick(() => {
              if (this.newerTask[0] && this.newerTask[0].state === 1) {
                this.scrollToAnchor(`beginner${this.dailyTask[0].eventId}`)
              }
            })
          }
          //
          else {
            this.newerTask = []
          }

          // dailyTask
          if (resData.dailyTask && resData.dailyTask.length) {
            let result = []
            let tempTask = this.transformTaskData(resData.dailyTask)
            result = result.concat(tempTask.filter((ele) => ele.state === 1))
            result = result.concat(tempTask.filter((ele) => ele.state === 0))
            result = result.concat(tempTask.filter((ele) => ele.state === 2))
            this.dailyTask = result

            this.$nextTick(() => {
              if (this.dailyTask[0] && this.dailyTask[0].state === 1) {
                this.scrollToAnchor(`daily${this.dailyTask[0].eventId}`)
              }
            })
          }
          //
          else {
            this.dailyTask = []
          }

          const params = {
            newbieBonusCount: resData.newerRewardCount || 0,
            dailyBonusCount: resData.dailyRewardCount || 0
          }
          try {
            updateUnreadOfManTask.postMessage(JSON.stringify(params))
          } catch (err) {
            console.log('try catch err:', err)
          }
        }
      })
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="less">
.male-signin-root {
  width: 100vw;
  min-height: 100vh;
  background: var(--page-color01, #fafafa) var(--icon-bg1) top left / 100% auto no-repeat;

  .custom-nav-block {
    background: var(--page-color02, #fafafa) var(--icon-bg1) top left / 100% auto no-repeat;
    .left-nav {
      width: 24px;
      height: 24px;
      background: var(--back-arrow) left top / 100% auto no-repeat;
    }
  }

  .male-signin-seven {
    width: 343px;
    height: 280px;
    margin: 12px auto 0;
    padding-top: 22px;
    position: relative;
    .signin-seven-check {
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      height: 108px;
      background: var(--icon-bg6) top left / 100% auto no-repeat;
    }
    .signin-seven-con {
      width: 100%;
      height: 258px;
      background: var(--icon-bg5) top left / 100% auto no-repeat;
      .sign-seven-tit {
        color: var(--page-color03, #202326);
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
        padding: 16px;
      }
      .sign-seven-props {
        position: relative;
        z-index: 1;
        padding: 14px 16px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .sign-seven-item {
          width: 74px;
          height: 83px;
          margin-bottom: 10px;
          border-radius: 8px;
          border: 1px solid transparent;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          .seven-item-block {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            > div {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              img {
                width: 32px;
                height: 32px;
              }
              span {
                font-family: Barlow;
                font-size: 12px;
                font-style: italic;
                font-weight: 500;
                line-height: 15px;
              }
            }
          }
          .seven-item-day {
            width: 100%;
            height: 20px;
            font-family: 'Inter 24pt';
            font-size: 11px;
            font-weight: 500;

            display: flex;
            align-items: center;
            justify-content: center;

            .got {
              width: 16px;
              height: 16px;
              background: var(--icon-got) top left / 100% auto no-repeat;
            }
          }
        }

        .seven-gap {
          min-width: 4px;
        }

        .item-on {
          background: var(--page-color04, #ffe5ad);
          border: 1px solid var(--page-color05, rgba(255, 255, 255, 0.7));
          .seven-item-block {
            background: var(--page-color06, rgba(255, 255, 255, 0.7));
            > div {
              span {
                color: var(--page-color07, #353a3f);
              }
            }
          }
          .seven-item-day {
            color: var(--page-color08, #202326);
          }
        }

        .item-off {
          border: 1px solid transparent;
          background: var(--page-color09, #fafafa);
          .seven-item-block {
            > div {
              span {
                color: var(--page-color10, #8e9092);
              }
            }
          }
          .seven-item-day {
            background: var(--page-color11, #e3e4e5);
            color: var(--page-color12, #8e9092);
          }
        }

        .item-long {
          width: 152px;
          .seven-item-block {
            .long-gap {
              width: 20px;
            }
          }
        }

        .current-on {
          border: 1px solid var(--page-color13, #ffa433);
          background: var(--page-color14, #ffa433);
          .seven-item-block {
            background: rgba(255, 255, 255, 0.7);
            > div {
              span {
              }
            }
          }
          .seven-item-day {
            background: var(--page-color15, #ffa433);
            color: var(--page-color16, #202326);
          }
        }
      }
    }
  }

  .sign-btn {
    width: 343px;
    height: 56px;
    margin: 12px auto;
    border-radius: var(--page-radius1, 56px);
    background: var(--page-color17, #fff4d6);
    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--page-color18, #ffb94d);
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;

    .sign-btn-icon {
      width: 24px;
      height: 24px;
      background: var(--icon-time) top left / 100% auto no-repeat;
    }
  }

  .btn-on {
    background: var(--page-color19, #ffa433);
    color: var(--page-color20, #733406);
  }

  .banner-swipe {
    width: 100%;
    margin-top: 20px;
    .swiper-root {
      width: 100%;
      .swiper-slide {
        width: 100%;
        .slide-item {
          width: 100%;
          height: auto;
          padding: 0 16px;
          position: relative;
          border-radius: 10px;
          color: #ffffff;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }

  .task-block {
    width: 343px;
    margin: 20px auto 0;
    padding-bottom: 20px;
    border-radius: 24px;
    border: 1px solid #fff;
    background: #fff;
    overflow: hidden;
    position: relative;

    .task-bg {
      width: 100%;
      height: 104px;
      background: var(--icon-bg3) right top / 125px auto no-repeat;
      position: absolute;
      top: 0;
      right: 0;
      user-select: none;
      pointer-events: none;
    }

    .task-top {
      width: 100%;
      min-height: 64px;
      padding: 16px 15px 0;
      margin-bottom: 20px;
      background: linear-gradient(180deg, var(--page-color21, #fff4d6) 0%, var(--page-color22, rgba(255, 255, 255, 0)) 100%);

      .task-head {
        color: var(--page-color23, #202326);
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
        padding-bottom: 5px;
        padding-left: 5px;
        background: var(--icon-bg2) bottom left/ 132px auto no-repeat;
      }
      .task-tips {
        color: var(--page-color24, #353a3f);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        padding: 0 5px;
      }
    }

    .task-item {
      width: 303px;
      height: fit-content;
      margin: 0 auto 20px;
      display: flex;
      align-items: flex-start;
      .item-icon {
        width: 48px;
        height: 48px;
        border-radius: 4px;
        background: var(--page-color25, #f0f1f2);
        img {
          width: 48px;
          height: 48px;
        }
      }
      .item-con {
        padding: 0 8px;
        flex: 1;
        p {
          color: var(--page-color26, #353a3f);
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
        }
        div {
          display: flex;
          align-items: center;

          color: var(--page-color27, #353a3f);
          font-family: 'Roboto Condensed';
          font-size: 18px;
          font-style: italic;
          font-weight: 600;
          line-height: 28px;

          img {
            width: 19px;
            margin: 0 2px;
          }
        }
      }
      .item-btn-wrap {
        width: 88px;
        height: 100%;

        .item-btn {
          margin-top: 8px;
          width: 88px;
          height: 32px;
          border-radius: var(--page-radius2, 32px);
          display: flex;
          align-items: center;
          justify-content: center;

          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          &.got {
            background: var(--page-color28, #f0f1f2);
            display: flex;
            align-items: center;
            justify-content: center;
            div {
              width: 16px;
              height: 16px;
              background: var(--icon-got) top left / 100% auto no-repeat;
            }
          }
          &.claim {
            background: var(--page-color29, #ffe41c);
            color: var(--page-color30, #733406);
          }
          &.start {
            background: var(--page-color31, #ffa433);
            color: var(--page-color32, #733406);
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background: var(--page-color33, rgba(0, 0, 0, 0.7));
    overflow-y: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .dia-con {
      width: 279px;
      padding-bottom: 24px;
      border-radius: var(--page-radius3, 24px);
      overflow: hidden;
      background: var(--page-color34, #fff);

      .dia-top {
        width: 100%;
        height: 80px;
        padding: 16px 0 12px;
        background: linear-gradient(180deg, var(--page-color35, #fff4d6) 0%, var(--page-color36, rgba(255, 255, 255, 0)) 100%);

        .dia-tit {
          color: var(--page-color37, #000);
          font-family: Roboto;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dia-tips {
          color: var(--page-color38, #353a3f);
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .reward-con {
        width: 247px;
        height: 68px;
        margin: 0 auto;

        display: flex;
        align-items: center;
        justify-content: space-between;

        .reward-item {
          height: 68px;
          border-radius: 8px;
          background: var(--page-color39, #fff4d6);

          color: var(--page-color40, #733406);
          font-family: 'Roboto Condensed';
          font-size: 20px;
          font-style: italic;
          font-weight: 600;
          line-height: 28px;

          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 52px;
            height: 52px;
          }
        }
      }

      .dia-btn {
        width: 247px;
        height: 48px;
        margin: 20px auto 0;
        border-radius: var(--page-radius4, 48px);
        background: var(--page-color41, #ffa433);
        display: flex;
        align-items: center;
        justify-content: center;

        color: var(--page-color42, #733406);
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: bold;
        line-height: 24px;
      }

      .dia-bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px 0 0;

        color: var(--page-color43, #8e9092);
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;

        .switch-block {
          width: 40px;
          height: 24px;
          margin: 0 4px;
          &.on {
            background: var(--icon-switchon) top left/ 100% auto no-repeat;
          }
          &.off {
            background: var(--icon-switchoff) top left/ 100% auto no-repeat;
          }
        }
      }
    }

    .reward1 {
      .dia-top {
        height: 64px;
      }
      .reward-con {
        .reward-item {
          width: 287px;
        }
      }
    }

    .reward2 {
      .reward-con {
        .reward-item {
          width: 117px;
        }
        .only {
          width: 287px;
        }
      }
    }
  }

  .van-nav-bar__left .tit-left {
    padding: 0 16px;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .male-signin-root {
    background: var(--page-color44, #fafafa) var(--icon-bg7) top left / 100% auto no-repeat;

    .custom-nav-block {
      background: var(--icon-bg7) top left / 100% auto no-repeat;
    }

    .male-signin-seven {
      .signin-seven-check {
        right: unset;
        left: 0;
        z-index: 2;
      }
      .signin-seven-con {
        background: var(--icon-bg9) top left / 100% auto no-repeat;
      }
    }

    .task-block {
      .task-bg {
        background: var(--icon-bg8) left top / 125px auto no-repeat;
      }

      .task-top {
        .task-head {
          background: var(--icon-bg2) bottom right/ 132px auto no-repeat;
        }
      }
    }
  }
}
</style>
